<!--文本内容-->
<template>
  <div>
    <!--头部-->
    <el-row>
      <el-col :span="4"><div class="grid_content"></div></el-col>
      <el-col :span="7">
        <div class="grid_content">
          <div class='logo' @click='skipHome()'>
            <img src="../../assets/images/logo.png" alt="logo"/>
          </div>
        </div>
      </el-col>

      <!--tabs导航栏-->
      <el-col :span="9">
        <div class="grid_content">
          <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="beforeTabLeave">
            <el-tab-pane label="首页" name="homePage">
            </el-tab-pane>
            <el-tab-pane label="主营业务" name="mainBusiness">
            </el-tab-pane>
            <el-tab-pane label="客户案例" name="customerStories"></el-tab-pane>
            <el-tab-pane label="新闻与资讯" name="newsCenter"></el-tab-pane>
            <el-tab-pane label="培训中心" name="trainingCenter"></el-tab-pane>
            <el-tab-pane label="关于埃文" name="aboutAvi"></el-tab-pane>
<!--            <el-tab-pane label="旧版接入" name="fourth"></el-tab-pane>-->
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid_content"></div></el-col>
    </el-row>

    <!--导航图-->
    <el-row>
      <el-col :span="24">
        <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in dataList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

    <!--页头-->
    <el-row class='row_top'>
      <el-col :span="1"><div class="grid_content"></div></el-col>
      <el-col :span="22">
        <div class="grid_content">
          <el-breadcrumb separator-class="el-icon-arrow-right" style='font-size:18px'>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item class='header' @click.native="jump">{{this.typeName}} </el-breadcrumb-item>
            <el-breadcrumb-item ></el-breadcrumb-item>

          </el-breadcrumb>
          <el-divider></el-divider>
        </div>
      </el-col>
      <el-col :span="1"><div class="grid_content"></div></el-col>
    </el-row>

    <!--tabs标签页-->
    <el-row>
      <el-col :span="4"><div class="grid_content"></div></el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid_content" style='background-color: #fff;min-height: 600px;height: 100%'>
          <div class='contentScope'>
            <!--内容-->
            <ul>
              <!--阅读、分享-->
              <li class='share'>
                 <div>
                   <p>编辑时间</p>
                   <span>{{this.releaseTime}}</span>
                 </div>
<!--                 <div>-->
<!--                   <p>移动阅读</p>-->
<!--                   <img src='../../assets/images/textContent/wx.png'  @click="share">-->
<!--                 </div>-->
                <div>
                  <p>好文分享</p>
                  <img src='../../assets/images/textContent/fx.png' @click="copy">
                </div>
              </li>
              <!--富文本-->
              <li class='textContent'>
                <p class='ql-editor' v-html='content'></p>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid_content"></div></el-col>
    </el-row>

    <!--插入尾部-->
    <div class="m-box" >
      <keep-alive>
        <component  :is='components.tail'></component>
      </keep-alive>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog title="移动阅读" :visible.sync='open' width='400px' :destroy-on-close='true' :modal='false' center>
      <el-form :model='productCategoryFrom' ref='productCategoryFrom'  label-width='80px'>
        <img style="width: 300px;height: 300px;" :src="qr_url" >
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import homePage from './homePage.vue'
import mainBusiness from './mainBusiness.vue'
import trainingCenter from './trainingCenter.vue'
import newsCenter from './newsCenter.vue'
import customerStories from './customerStories.vue'
import aboutAvi from './aboutAvi.vue'
import platformPartners from './platformPartners.vue'
import footer from './footer.vue'
import 'quill/dist/quill.core.css'
import expert from './expert.vue'
import { selectCarouselPicture, selectCaseId, selectNewsId } from '../../api/auth'
export default {
  created () {
    this.$nextTick(function () {
      if (this.$route.query.type != null && this.$route.query.type > 0) {
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        if (this.type === '1') {
          this.selectCaseId()
          this.nameType = '客户案例'
        } else if (this.type === '2') {
          this.nameType = '新闻与资讯'
          this.selectNewsId()
        }
      }
    })
  },
  data () {
    return {
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      fits: ['cover'],
      tabPosition: 'left',
      activeName: 'second',
      nameType: '',
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      isChildUpdate1: true,
      isChildUpdate2: false,
      isChildUpdate3: false,
      qr_url: '',
      isChildUpdate4: false,
      isChildUpdate5: false,
      isChildUpdate6: false,
      isChildUpdate7: false,
      components: {
        child0: homePage,
        child1: mainBusiness,
        child2: trainingCenter,
        child3: newsCenter,
        child4: aboutAvi,
        child5: customerStories,
        child7: platformPartners,
        child8: expert,
        tail: footer
      },
      queryParams: {
        id: 1
      },
      // 类别表单
      productCategoryFrom: {
        id: null,
        parentId: 0,
        userName: '',
        code: null,
        content: '',
        title: '',
        profile: '',
        phone: '',
        author: '',
        imageUrl: '',
        isDisplay: '',
        releaseTime: null,
        educationType: '',
        type: '',
        image: [],
        showIndex: 0
      },
      // 是否显示弹出层
      open: false,
      content: '',
      releaseTime: '',
      id: null,
      type: null,
      enterpriseParams: {
        type: 6
      },
      dataList: [],
      typeName: '',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      tableData: {
        content: '',
        releaseTime: ''
      }
    }
  },
  methods: {
    /** 滚动图  */
    selectEnterprisePicture (raw) {
      let that = this
      this.enterpriseParams.type = raw
      selectCarouselPicture(this.enterpriseParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.dataList = res
      })
    },
    /** 根据ID查询新闻详情 */
    selectNewsId (type) {
      let that = this
      that.queryParams.id = that.id
      selectNewsId(that.queryParams).then(res => {
        that.tableData.content = res.content
        that.tableData.releaseTime = res.releaseTime
        that.content = res.content
        that.releaseTime = res.releaseTime
        if (res.type === '1') {
          this.selectEnterprisePicture(7)
          this.typeName = '公司新闻'
        } else if (res.type === '2') {
          this.selectEnterprisePicture(8)
          this.typeName = '行业资讯'
        } else if (res.type === '3') {
          this.selectEnterprisePicture(9)
          this.typeName = '埃文博士观点'
        }
      })
    },
    /** 根据ID查询新闻详情 */
    selectCaseId (type) {
      let that = this
      that.queryParams.id = that.id
      selectCaseId(that.queryParams).then(res => {
        that.tableData.content = res.content
        that.tableData.releaseTime = res.releaseTime
        that.releaseTime = res.releaseTime
        that.content = res.content
        if (res.type === '1') {
          this.typeName = '政府案例'
          this.selectEnterprisePicture(5)
        } else if (res.type === '2') {
          this.typeName = '企业案例'
          this.selectEnterprisePicture(6)
        }
      })
    },
    details (raw) {
      this.$router.push({
        path: '/index',
        query: {
          type: raw
        }
      })
    },
    skipHome (raw) {
      this.$router.push({
        path: '/'
      })
    },
    jump () {
      if (this.nameType === '新闻与资讯') {
        if (this.typeName === '公司新闻') {
          this.$router.push({
            path: '/index',
            query: {
              type: 'journalism'
            }
          })
        } else if (this.typeName === '行业资讯') {
          this.$router.push({
            path: '/index',
            query: {
              type: 'industry'
            }
          })
        } else if (this.typeName === '埃文博士观点') {
          this.$router.push({
            path: '/index',
            query: {
              type: 'avi'
            }
          })
        }
      } else if (this.nameType === '客户案例') {
        if (this.typeName === '政府案例') {
          this.$router.push({
            path: '/index',
            query: {
              type: 'first'
            }
          })
        } else if (this.typeName === '企业案例') {
          this.$router.push({
            path: '/index',
            query: {
              type: 'second'
            }
          })
        }
      }
    },
    share () {
      this.qr_url = 'https://api.qrserver.com/v1/create-qr-code?data=' + window.location.href
      this.open = true
    },
    copy () {
      // 1. 创建并添加一个输入框元素(最后会销毁)
      const textareaEle = document.createElement('textarea')
      document.body.appendChild(textareaEle)
      // 2. 将需要复制的文本传入输入框, 并调用 select 方法, 选中输入框中文本
      textareaEle.value = window.location.href
      textareaEle.select()
      textareaEle.readOnly = 'readOnly'
      // 3. 调用复制选中文本的方法
      document.execCommand('copy')
      // 4. 销毁输入框
      document.body.removeChild(textareaEle)
      alert('恭喜您，已复制成功,请前去分享')
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = true
        this.details('homePage')
      } else if (tab.name === 'mainBusiness') {
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.details('mainBusiness')
      } else if (tab.name === 'customerStories') {
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.details('customerStories')
      } else if (tab.name === 'newsCenter') {
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.details('newsCenter')
      } else if (tab.name === 'trainingCenter') {
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = true
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.details('trainingCenter')
      } else if (tab.name === 'aboutAvi') {
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = true
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.details('aboutAvi')
      } else if (tab.name === 'fourth') {
        window.open('http://avicanton.org/', '_blank')
      }
    },
    // tabs切换拦截
    beforeTabLeave (newIndex, oldIndex) {
      if (newIndex === 'fourth') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.block{
  .image-slot{
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
  }
}

.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}
.grid_content {
  min-height:100px;
  .logo{
    line-height: 100px;
    img{
      height: 40px;
    }
  }
  .contentScope{
    min-height: 550px;
    li{
      display: block;
      float: left;
    }
    .share{
      width: 12%;
      border-right: 2px solid #d7d7d7;
      div{
        margin-bottom: 20px;
        p{
          text-align: center;
          padding-bottom:5px;
        }
        span{
          display: block;
          text-align: center;
        }
        img{
          display: block;
          margin: 0 auto;
          cursor:pointer;
        }
      }
    }
    .textContent{
      width: 88%;
      padding:0 15px;
    }
  }
}
.text{
  padding: 15px;
}

//Tabs标签页
::v-deep .el-tabs__nav-scroll{
  width:100%;
  display: block;
  line-height: 100px;
  .el-tabs__nav{
    width: 100%;
    text-align: center;
    margin: 0 auto;
    z-index: 0;
  }
  .el-tabs__item{
    font-family: "MicrosoftYaHei";
    font-size: 16px;
    color: #666;
  }
  .el-tabs__item:hover{
    color: #11a84e;
  }
  .el-tabs__item:focus{
    color: #11a84e;
  }
}
::v-deep .el-tabs__nav-wrap::after{
  color: #11a84e;
}
::v-deep .el-tabs__nav-scroll .el-tabs__item.is-active {
  color: #11a84e;
}
.carousel_class {
  //height: 260px;
  margin: 0;
  padding: 0;
}
.row_top{
  margin-top: 20px;
}
.header{
  cursor:pointer;
  font-family: "MicrosoftYaHei";
}
::v-deep img{
  max-width:100%;
}
</style>
